import { ReactNode } from "react";
import { StyledItemLink } from "./FinaSidebar.style";

const MenuItem = ({
  content,
  icon,
  isActive,
  to,
  collapse,
}: {
  content: string;
  icon: ReactNode;
  isActive?: boolean;
  to: string;
  collapse?: boolean;
}) => {
  return (
    <StyledItemLink isActive={isActive} $collapse={collapse} to={to}>
      {icon}
      <span>{content}</span>
    </StyledItemLink>
  );
};
export { MenuItem as default };
